import { PortainerNamespaceAccessesConfigMap } from '@/react/kubernetes/configs/constants';
import { User } from '@/portainer/users/types';
import { Team } from '@/react/portainer/users/teams/types';
import { Configuration } from '@/react/kubernetes/configs/types';
import { RbacRole } from '@/react/portainer/users/RolesView/types';

import { NamespaceAccess, NamespaceAccessesMap } from './types';

export function parseNamespaceAccesses(
  data: Configuration | null,
  namespaceName: string,
  users: User[],
  teams: Team[],
  roles?: RbacRole[]
): NamespaceAccess[] {
  if (!data?.Data) {
    return [];
  }

  const rawAccesses = data.Data[PortainerNamespaceAccessesConfigMap.accessKey];
  if (!rawAccesses) {
    return [];
  }

  try {
    const namespacesAccesses: NamespaceAccessesMap = JSON.parse(rawAccesses);
    const namespaceAccesses = namespacesAccesses[namespaceName];
    if (!namespaceAccesses) {
      return [];
    }

    const userAccesses = Object.entries(
      namespaceAccesses.UserAccessPolicies || {}
    ).flatMap(([userId, policy]) => {
      const user = users.find((u) => u.Id === parseInt(userId, 10));
      if (!user) {
        return [];
      }

      const roleId = (policy as { RoleId: number }).RoleId;
      const role = roles?.find((r) => r.Id === roleId);

      return [
        {
          id: user.Id,
          name: user.Username,
          type: 'user' as const,
          role: role
            ? { id: role.Id, name: role.Name }
            : { id: roleId, name: '' },
        },
      ];
    });

    const teamAccesses = Object.entries(
      namespaceAccesses.TeamAccessPolicies || {}
    ).flatMap(([teamId, policy]) => {
      const team = teams.find((t) => t.Id === parseInt(teamId, 10));
      if (!team) {
        return [];
      }

      const roleId = (policy as { RoleId: number }).RoleId;
      const role = roles?.find((r) => r.Id === roleId);

      return [
        {
          id: team.Id,
          name: team.Name,
          type: 'team' as const,
          role: role
            ? { id: role.Id, name: role.Name }
            : { id: roleId, name: '' },
        },
      ];
    });

    return [...userAccesses, ...teamAccesses];
  } catch {
    return [];
  }
}
